import React from 'react';
import PropTypes from 'prop-types';

const SortSelect = ({ 
    value, 
    onChange, 
    options, 
    className = '', 
    style = {},
    name = 'sortBy'
}) => {
    const defaultStyle = {
        padding: '0.25rem',
        border: '1px solid #ced4da',
        borderRadius: '0.25rem',
        boxShadow: 'inset 0 0 0 transparent',
        transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
    };

    return (
        <div className="col-sm-3 ml-3">
            <select
                className={`mr-0 ${className}`}
                style={{ ...defaultStyle, ...style }}
                name={name}
                value={value}
                onChange={onChange}
            >
                {Object.values(options).map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

SortSelect.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.shape({
        [PropTypes.string]: PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired
        })
    }).isRequired,
    className: PropTypes.string.isRequired,
    style: PropTypes.shape({
        padding: PropTypes.string,
        border: PropTypes.string,
        borderRadius: PropTypes.string,
        boxShadow: PropTypes.string,
        transition: PropTypes.string
    }).isRequired,
    name: PropTypes.string.isRequired
};

export default SortSelect; 